/*
 * ApplicationShiftDetails Messages
 *
 * This contains all the text for the ApplicationShiftDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.PrecedingAndFollowingTeams.title',
    defaultMessage: 'Preceding and following teams',
  },
});
